export default __webpack_public_path__ + "static/media/bernay12.811a5bfa.jpg";